<template>
  <v-dialog v-model="show" persistent max-width="420">
    <v-card>
      <v-card-title class="text-h6">Verificação em duas etapas</v-card-title>
      <v-card-text>
        <p>{{ mensagem }}</p>
        <v-form @submit.prevent="confirmar">
          <v-text-field
            v-model="codigo"
            label="Código"
            data-cy="Código"
            outlined
            autofocus
            maxlength="10"
            inputmode="numeric"
            autocomplete="one-time-code"
            :disabled="carregando"
          />
        </v-form>
        <v-alert v-show="erro" type="error" text dense>{{ erro }}</v-alert>
        <v-alert v-show="info" type="success" text dense>{{ info }}</v-alert>
      </v-card-text>
      <v-card-actions>
        <v-btn
          text
          :disabled="carregando || segundosReenvio > 0"
          @click="reenviarCodigo"
        >
          {{ segundosReenvio > 0 ? `Reenviar (${segundosReenvio}s)` : 'Reenviar código' }}
        </v-btn>
        <v-spacer />
        <v-btn text :disabled="carregando" @click="cancelar">Cancelar</v-btn>
        <v-btn
          color="primary"
          :loading="carregando"
          :disabled="!codigo"
          @click="confirmar"
        >
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const ESPERA_REENVIO_SEGUNDOS = 30;
const MENSAGEM_PADRAO = 'Enviamos um código de verificação para o seu e-mail. Informe o código para continuar.';

export default {
  props: {
    mfa: { type: Object, required: true },
    validar: { type: Function, required: true },
    reenviar: { type: Function, required: true },
  },
  data () {
    return {
      show: true,
      codigo: '',
      mensagem: this.mfa.mfaMensagem || MENSAGEM_PADRAO,
      erro: '',
      info: '',
      carregando: false,
      segundosReenvio: ESPERA_REENVIO_SEGUNDOS,
      timer: null,
    };
  },
  mounted () {
    this.iniciarEsperaReenvio();
  },
  beforeDestroy () {
    clearInterval(this.timer);
  },
  methods: {
    confirmar () {
      const th = this;
      if (!th.codigo || th.carregando) return;

      th.carregando = true;
      th.erro = '';
      th.info = '';
      th.validar(th.codigo.trim())
        .then((data) => {
          if (data && data.success === false) {
            th.erro = data.mensagem || 'Não foi possível validar o código. Tente novamente.';
          } else if (data && data.mfaRequired) {
            th.codigo = '';
            th.erro = data.errorMessage || data.errorDescription || 'Código inválido.';
          } else {
            // tokens liberados, ou erro da senha (conta travada etc.) para a tela de login exibir
            th.$emit('concluido', data);
          }
        })
        .finally(() => {
          th.carregando = false;
        });
    },
    reenviarCodigo () {
      const th = this;
      th.carregando = true;
      th.erro = '';
      th.info = '';
      th.reenviar()
        .then((data) => {
          if (data && data.success === false) {
            th.erro = data.mensagem || 'Não foi possível reenviar o código. Tente novamente.';
          } else if (data && data.mfaRequired) {
            th.mensagem = data.mfaMensagem || th.mensagem;
            th.info = 'Enviamos um novo código.';
            th.iniciarEsperaReenvio();
          } else {
            // sem MFA ou erro da senha: devolve para a tela de login
            th.$emit('concluido', data);
          }
        })
        .finally(() => {
          th.carregando = false;
        });
    },
    cancelar () {
      this.$emit('cancelado');
    },
    iniciarEsperaReenvio () {
      const th = this;
      clearInterval(th.timer);
      th.segundosReenvio = ESPERA_REENVIO_SEGUNDOS;
      th.timer = setInterval(() => {
        th.segundosReenvio -= 1;
        if (th.segundosReenvio <= 0) clearInterval(th.timer);
      }, 1000);
    },
  },
};
</script>
